import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalWithTrigger } from '../modal';
import { Button } from '../../actions/button/button';
import { InfoIcon } from '../../../icons/info-icon';

export const Deposits = () => {
	const { t } = useTranslation();
	return (
		<ModalWithTrigger
			trigger={
				<Button startIcon={<InfoIcon />} variant='link'>
					{null}
				</Button>
			}
		>
			<Modal.Header>{t('checkout.modals.deposits.title')}</Modal.Header>
			<Modal.Body>
				<p>
					{t('checkout.modals.deposits.description1')}
				</p>
				<p>
					{t('checkout.modals.deposits.description2')}
				</p>
			</Modal.Body>
			<Modal.Footer>
				<Modal.Close>
					<Button variant='tertiary' fullWidth>
						{t('checkout.modals.deposits.dismiss')}
					</Button>
				</Modal.Close>
			</Modal.Footer>
		</ModalWithTrigger>
	);
};
